export const STRAPI_URL: string =
  import.meta.env.VITE_STRAPI_URL ?? "http://localhost:1337";
export const HOME_PORTAL_URL: string =
  import.meta.env.VITE_HOME_PORTAL_URL ?? "http://localhost:1338";

// Product apps only get the Home Portal backend URL, so its frontend is looked up from it.
const HOME_PORTAL_FRONTEND_BY_BACKEND: Record<string, string> = {
  "https://home-portal-staging-backend.cloud.hipsquare.io":
    "https://home-portal-staging.cloud.hipsquare.io/",
};
export const HOME_PORTAL_LINK =
  HOME_PORTAL_FRONTEND_BY_BACKEND[HOME_PORTAL_URL.replace(/\/+$/, "")] ??
  "https://home.pimoapp.com/";

export const APP_INSIGHTS_CONNECTION_STRING = import.meta.env
  .VITE_APP_INSIGHTS_CONNECTION_STRING;

export const THEME_NAME: string =
  import.meta.env.VITE_THEME_NAME ?? "pimo-theme-placeholder";
